<template>
    <div class="certain-category-search-wrapper">
        <a-auto-complete dropdown-class-name="certain-category-search-dropdown" :dropdown-match-select-width="false"
            :dropdown-style="{ width: '300px' }" size="large" style="width: 100%" placeholder="input here"
            option-label-prop="aweme_id">
            <!-- <template slot="dataSource">
                <a-select-opt-group>
                    <span slot="label" class="aweme-top">
                        官方授权号
                        <a style="float: right;color: #194ce5;" href="javascript:void(0);"> +
                            新增授权
                        </a>
                    </span>
                    <a-select-option v-for="opt in dataSource" :key="opt.title" :value="opt.aweme_id">
                        <div class="select-aweme" @click="changAweme(opt)">
                            <img :src="opt.aweme_avatar" alt="avatar" class="aweme-avatar" />
                            <div class="aweme-right">
                                <div class="aweme-info">
                                    <div class="aweme-name">{{ opt.aweme_name }}</div>
                                    <div class=" official">
                                        官方
                                    </div>
                                </div>
                                <div class="aweme-show-id">{{ opt.aweme_id }}</div>
                            </div>
                        </div>
                    </a-select-option>
                </a-select-opt-group>  
                <a-select-opt-group >
                    <span slot="label" class="aweme-top">
                        近期投放
                    </span> 
                    <a-select-option v-for="opt in nearList" :key="opt.ad_id" :value="opt.ad_id">
                        <div class="select-aweme" @click="changAwemeTo(opt)">
                            <img :src="opt.aweme_avatar" alt="avatar" class="aweme-avatar" />
                            <div class="aweme-right">
                                <div class="aweme-info">
                                    <div class="aweme-name">{{ opt.aweme_name }}</div>
                                    <div class=" official">
                                        历史
                                    </div>
                                </div>
                                <div class="aweme-show-id">{{ opt.aweme_id }}</div>
                            </div>
                        </div>
                    </a-select-option>
                </a-select-opt-group>

            </template> -->
            <div class="aweme_list" @click="showBt()">
                <img :src="selectRes.aweme_avatar || dataSource[0].aweme_avatar" alt="avatar" class="account-avatar">
                <div class="account-name">{{ selectRes.aweme_name || dataSource[0].aweme_name }}</div>
                <div class="auth-type-tag"> 官方 </div>
                <a-icon type="down" class="down" />
            </div>
        </a-auto-complete>

        <a-drawer class="authAccount" title="可投抖音号列表" width="600px" :visible="btVisible" placement="right" @close="btVisible=false">
            <div class="searchWapper">  
                <a-radio-group :value="zhtype" @change="handleZhChange" style="width: 100%;">
                <a-radio-button value="GF"  style="width: 32%;text-align: center;">
                  官方授权号
                </a-radio-button>
                <a-radio-button value="GL"  style="width: 32%;text-align: center;">
                  关联抖音号
                </a-radio-button>
                <a-radio-button value="NEAR"  style="width: 36%;text-align: center;">
                  历史投放号
                </a-radio-button> 
              </a-radio-group> 
            </div>
            <div>  
                <div>
                    <a-input-search :allowClear="true" placeholder="抖音昵称/抖音ID" v-model="searchKey" enter-button @search="onSearchKey"  />
                </div>
                
                <a-spin :spinning="loading" tip="加载中...">
                    <div class="shop-list" style="margin-top: 10px;height: 85vh;overflow: auto;" v-if="zhtype=='GF' && new_dataSource.length>0">
                        <div  @click="changAweme(opt)" :class="selectRes.aweme_id==opt.aweme_id ?'shop-account-item selected':'shop-account-item'" v-for="opt in new_dataSource" :key="opt.aweme_id" :value="opt.aweme_id">
                            <div class="shop-account-avatar" style="border-radius: 50%;">
                                <img style="height: 50px;border-radius: 50%;" :src="opt.aweme_avatar||'http://api.douchuanec.com/assets/img/empty2.png'" />
                            </div>
                            <div class="shop-account-text">
                                <div class="byted-popover-wrapper">
                                <div class="ellipsis-text-component" :title="opt.aweme_name"> 
                                    <a-tooltip placement="top" :title="opt.aweme_name">
                                    {{opt.aweme_name||'-'}}
                                    </a-tooltip>  
                                </div>
                                </div>
                                <div class="shop-account-data" :title="opt.aweme_id">UID:{{opt.aweme_id}} <a-icon type="copy" @click="text_copy(opt.aweme_id)"/></div> 
                            </div> 
                            <div  class="selected-con" v-if="selectRes.aweme_id==opt.aweme_id">
                                <img src="//p1-ecom.byteimg.com/tos-cn-i-55ejei7tpt/eb4c48325f3c405da4a37af2b4dc8842~tplv-55ejei7tpt-image.image" alt="" class="selected-con-bg"><img data-v-73a17e34="" src="//p1-ecom.byteimg.com/tos-cn-i-55ejei7tpt/44e1bcb881e3451b9a3185d60fe53882~tplv-55ejei7tpt-image.image" alt="" class="selected-con-icon">
                            </div>
                        </div>  
                    </div> 
                    
                    <div class="shop-list" style="margin-top: 10px;height: 85vh;overflow: auto;" v-if="zhtype=='GL'&& new_glList.length>0">
                        <div  @click="changAweme(opt)" :class="selectRes.aweme_id==opt.aweme_id ?'shop-account-item selected':'shop-account-item'" v-for="opt in new_glList" :key="opt.aweme_id" :value="opt.aweme_id">
                            <div class="shop-account-avatar" style="border-radius: 50%;">
                                <img style="height: 50px;border-radius: 50%;" :src="opt.aweme_avatar||'http://api.douchuanec.com/assets/img/empty2.png'" />
                            </div>
                            <div class="shop-account-text">
                                <div class="byted-popover-wrapper">
                                <div class="ellipsis-text-component" :title="opt.aweme_name"> 
                                    <a-tooltip placement="top" :title="opt.aweme_name">
                                    {{opt.aweme_name||'-'}}
                                    </a-tooltip>  
                                </div>
                                </div>
                                <div class="shop-account-data" :title="opt.aweme_id">UID:{{opt.aweme_id}} <a-icon type="copy" @click="text_copy(opt.aweme_id)"/></div> 
                            </div> 
                            <div  class="selected-con" v-if="selectRes.aweme_id==opt.aweme_id">
                                <img src="//p1-ecom.byteimg.com/tos-cn-i-55ejei7tpt/eb4c48325f3c405da4a37af2b4dc8842~tplv-55ejei7tpt-image.image" alt="" class="selected-con-bg"><img data-v-73a17e34="" src="//p1-ecom.byteimg.com/tos-cn-i-55ejei7tpt/44e1bcb881e3451b9a3185d60fe53882~tplv-55ejei7tpt-image.image" alt="" class="selected-con-icon">
                            </div>
                        </div>  
                    </div> 

                    <div class="shop-list" style="margin-top: 10px;height: 85vh;overflow: auto;" v-if="zhtype=='NEAR' && new_nearList.length>0">
                        <div  @click="changAweme(opt)" :class="selectRes.aweme_id==opt.aweme_id ?'shop-account-item selected':'shop-account-item'" v-for="opt in new_nearList" :key="opt.aweme_id" :value="opt.aweme_id">
                            <div class="shop-account-avatar" style="border-radius: 50%;">
                                <img style="height: 50px;border-radius: 50%;" :src="opt.aweme_avatar||'http://api.douchuanec.com/assets/img/empty2.png'" />
                            </div>
                            <div class="shop-account-text">
                                <div class="byted-popover-wrapper">
                                <div class="ellipsis-text-component" :title="opt.aweme_name"> 
                                    <a-tooltip placement="top" :title="opt.aweme_name">
                                    {{opt.aweme_name||'-'}}
                                    </a-tooltip>  
                                </div>
                                </div>
                                <div class="shop-account-data" :title="opt.aweme_id">UID:{{opt.aweme_id}} <a-icon type="copy" @click="text_copy(opt.aweme_id)"/></div> 
                            </div> 
                            <div  class="selected-con" v-if="selectRes.aweme_id==opt.aweme_id">
                                <img src="//p1-ecom.byteimg.com/tos-cn-i-55ejei7tpt/eb4c48325f3c405da4a37af2b4dc8842~tplv-55ejei7tpt-image.image" alt="" class="selected-con-bg"><img data-v-73a17e34="" src="//p1-ecom.byteimg.com/tos-cn-i-55ejei7tpt/44e1bcb881e3451b9a3185d60fe53882~tplv-55ejei7tpt-image.image" alt="" class="selected-con-icon">
                            </div>
                        </div>  
                    </div> 
                </a-spin>

            </div>  
        </a-drawer>

    </div>
</template>

<script>
import { qcApi, requestHttp } from '@utils/index';
export default {
    name: 'awemeList',
    props: {
        dataSource: {
            type: Array,
        },
        glList: {
            type: Array,
        },
        nearList: {
            type: Array,
        },
        action: {
            type: String,
            default: '',
        },
        advertiser_id: {
            type: String,
            default: '',
        },
    },
    data() {
        return { 
            selectRes: {
                aweme_avatar: '',
                aweme_name: '',
                aweme_id: '',
            },
            searchKey:'',
            btVisible:false,
            zhtype:'GF',
            new_dataSource:this.dataSource,
            new_glList:this.glList,
            new_nearList:this.nearList,
            loading:false
        };
    },

    components: {},

    watch: {},

    mounted() {
        console.log('数据', this.dataSource)
        console.log('222', this.dataSource[0])  
        let advertiser_id = this.advertiser_id
        let selectRes = this.dataSource.filter(function(item){
            return advertiser_id == item.advertiser_id
        }) 
        this.selectRes.aweme_avatar = selectRes[0].aweme_avatar
        this.selectRes.aweme_name = selectRes[0].aweme_name
        this.selectRes.aweme_id = selectRes[0].aweme_id
        if(this.action == 'getVideoId'){
            this.getVideoData(selectRes[0]);
        } 
        this.searchKey = ''
    },
    methods: { 
        showBt(){
            this.searchKey = ''
            this.onSearchKey()
            this.btVisible = true
        },
        onSearchKey(){
            if(this.zhtype == 'GF'){
                this.getAdvertiserSearch()
            }else if(this.zhtype == 'GL'){
                this.getGlData()
            }else{
                this.getNearData()
            }
        },
        async getAdvertiserSearch(){
            this.loading = true
            const { code, msg, data } = await requestHttp({
                api: `${qcApi.GET_ADVERTISER_LIST}`,
                method: 'POST',
                params: {
                    type: 'SXT',
                    account:this.searchKey
                },
            });
            this.loading = false
            if (code == 0) {
                this.$message.error(msg);
                return;
            }
            if (!data) return;
            this.new_dataSource = data.list
        },
        async getGlData() {
            this.loading = true
            const { code, msg, data } = await requestHttp({
                // api: `${qcApi.SXT_AWEME_NEAR_CREATE}`,
                api: `${qcApi.SXT_AWEME_AUTHORIZED}`,
                method: 'POST',
                params: {
                    advertiser_id: this.advertiser_id,
                    account:this.searchKey
                },
            });
            this.loading = false
            if (code == 0) {
                this.$message.error(msg);
                return;
            }
            this.new_glList = data.aweme_id_list
            console.log('近期投放', data.list)
        },
        async getNearData() {
            this.loading = true
            const { code, msg, data } = await requestHttp({
                // api: `${qcApi.SXT_AWEME_NEAR_CREATE}`,
                api: `${qcApi.SXT_AWEME_NEAR_CREATE_LIVE}`,
                method: 'POST',
                params: {
                    advertiser_id: this.advertiser_id,
                    account:this.searchKey
                },
            });
            this.loading = false
            if (code == 0) {
                this.$message.error(msg);
                return;
            }
            this.new_nearList = data.list
            console.log('近期投放', data.list)
        },
        handleZhChange(e){
            this.zhtype = e.target.value
            this.searchKey = ''
            if(this.zhtype == 'GF'){
                this.getAdvertiserSearch()
            }else if(this.zhtype == 'GL'){
                this.getGlData()
            }else{
                this.getNearData()
            }
        },
        async getVideoData(e) {
            // const { code, msg, data } = await requestHttp({
            //     api: `${qcApi.SXT_AWEME_VIDEO_GET}`,
            //     method: 'POST',
            //     params: {
            //         access_token: e.access_token,
            //         advertiser_id: e.advertiser_id,
            //         aweme_id: e.aweme_id,
            //         aweme_name: e.aweme_name,
            //         marketing_goal:'LIVE_PROM_GOODS'
            //     },
            // });
            // if (code == 0) {
            //     this.$message.error(msg);
            //     return;
            // }
            // if (!data) return;
            e.source = 'api'
            console.log('向子组件传值',e)
            this.$emit('getVideoData',e)
            //把data数据回传
        },
        // async getVideoData(e) {
        //     const { code, msg, data } = await requestHttp({
        //         api: `${qcApi.SXT_AWEME_VIDEO_GET}`,
        //         method: 'POST',
        //         params: {
        //             access_token: e.access_token,
        //             advertiser_id: e.advertiser_id,
        //             aweme_id: e.aweme_id,
        //             aweme_name: e.aweme_name,
        //             marketing_goal:'LIVE_PROM_GOODS'
        //         },
        //     });
        //     if (code == 0) {
        //         this.$message.error(msg);
        //         return;
        //     }
        //     if (!data) return;
        //     console.log('向子组件传值',data)
        //     this.$emit('getVideoData',data)
        //     //把data数据回传
        // },
        async getAwemeVideo(e){
            // const { code, msg, data } = await requestHttp({
            //     api: `${qcApi.SXT_OTHER_VIDEO_GET}`,
            //     method: 'POST',
            //     params: {
            //         aweme_id: e.aweme_id,
            //         marketing_goal:'LIVE_PROM_GOODS'
            //     },
            // });
            //   if(code == 0) {
            //     this.$message.error(msg);
            //     return;
            // }
            // // debugger
            
            // if (!data) return;
            e.source = 'near'
            console.log('向子组件传值',e)
            this.$emit('getVideoData',e)
        },
        changAweme(e) {
            console.log('被投官方授权切换', this.action)
            this.selectRes = e
            this.btVisible = false
            this.getVideoData(e)
        },
        changAwemeTo(e){
            console.log('222', this.action)
            this.selectRes = e
            // this.getVideoData(e)
            this.getAwemeVideo(e);
        }
    },
};
</script>

<style lang="less" scoped>
.certain-category-search-wrapper {
    width: 300px;
}

.aweme_list {
    position: relative;
    width: 280px;
    height: 40px;
    display: flex;
    background-color: #f4f4f4;
    border-radius: 4px;
    align-items: center;
    padding-right: 26px;
    padding-left: 12px;
    cursor: pointer;

    .account-avatar {
        margin-right: 8px;
        width: 20px;
        height: 20px;
        border-radius: 50%;
    }

    .account-name {
        overflow: hidden;
        flex: 1;
        margin-right: 8px;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: left;
        margin-left: 5px;
    }

    .auth-type-tag {
        color: #194ce5;
        background: #edf1fd;
        display: flex;
        justify-content: center;
        align-items: center;
        line-height: 16px;
        height: 16px;
        font-size: 12px;
        padding: 0 4px;
        border-radius: 2px;
        font-weight: normal;
    }

    .down {
        position: absolute;
        top: 50%;
        right: 6px;
        margin-top: -7px;

    }
}

.select-aweme {
    cursor: pointer;
    border-radius: 4px;
    padding: 16px 8px;
    display: flex;
    align-items: center;

    .aweme-avatar {
        display: block;
        height: 32px;
        width: 32px;
        margin-right: 8px;
        border-radius: 50%;
    }

    .aweme-right {
        flex: 1;
    }
}


.aweme-name {
    flex: 1;
    font-size: 14px;
    line-height: 20px;
    height: 20px;
    margin-right: 8px;
    width: 145px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.aweme-info {
    position: relative;
}

.official {
    position: absolute;
    color: #194ce5;
    background: #edf1fd;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 16px;
    height: 16px;
    font-size: 12px;
    padding: 0 4px;
    border-radius: 2px;
    font-weight: normal;
    right: 0px;
    top: 10px;
}

.aweme-show-id {
    font-family: PingFang SC;
    font-size: 12px;
    line-height: 16px;
    height: 16px;
    color: #666;
}
.searchWapper{
  margin-bottom: 20px;
}
.tips{
  margin-bottom: 10px;
}
.searchResult{
  display: flex;
}
.searchLeft{
  background-color: #fff;
  border-radius: 8px 0 0;
  border-right: 1px solid #e5e5e5;
  overflow-y: auto;
  transition: width 0.15s ease-in-out;
  width: 260px;
  // height: calc(100vh - 60px);
  padding-top: 5px;
}
.shop-list{
  cursor: pointer;
}
.shop-account-item {
  align-items: center;
  border-radius: 4px;
  display: flex;
  height: 80px;
  justify-content: flex-start;
  padding: 16px;
  position: relative;
  width: 100%;
  margin-bottom: 10px;
  background: #f7f7f7;
}
.shop-account-item.selected {
  background: #edf1fd;
  position: relative;
}
.shop-account-item.selected::before {
  background-color: #1890ff;
  border-radius: 4px;
  content: "";
  display: block;
  height: 24px;
  left: 0;
  margin-top: -12px;
  position: absolute;
  top: 50%;
  width: 4px;
}
.shop-account-text {
  margin-left: 9px;
  // width: 130px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
}
.ellipsis-text-component {
  // width: 124px;
  font-size: 12px;
  font-weight: 600;
  color: #333333;
  cursor: pointer;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  display: -moz-box;
  -moz-line-clamp: 3;
  overflow-wrap: break-word;
  word-break: break-all;
  white-space: normal;
  overflow: hidden;
  line-height: 16px;
}
.shop-account-data {
  color: #999;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
}
.searchRight{
  width: 900px;
  height: 100%;
  display: flex;
}
.material-row-bottom {
  position: absolute;
  width: 100%;
}
.common-loading-container {
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.authTypeWapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  max-height: 60vh;
  overflow: auto;

  .authImg {
    width: 748px;
    height: 544px;
    margin: 0 auto;
  }

  .authBtn {
    cursor: pointer
  }
} 

.drawer-footer-btns{
  flex: 1;
  display: flex;
  justify-content: end;
  align-items: center;
}

.authTxt {
  margin: 0 auto;
  width: 90%;
  text-align: left;
  font-size: 12px;
  margin-bottom: 5px;
}
.rowOperate {
  // display: flex;
  align-items: center;
  justify-content: flex-start;
  .actionItem {
    margin-left: 5px;
    color: #597ef7;
    cursor: pointer;

    &:last-child {
      margin-right: 0;
    }
  }
}
.material-virtual-viewport {
  overflow: auto;
  position: relative;
  margin-top:5px;
  padding-left: 20px;
  &::-webkit-scrollbar {
    display: none;
  }
}

.material-item {
  width: 180px;
  height: 270px;
  background: pink;
}

.material-row {
  // position: absolute;
  // display: flex;
  // justify-content: space-between;

  ::v-deep .video-container:not(:last-child) {
    margin-right: 26px;
  }
}

.goodImg {
  border-radius: 4px;
  height: 86px;
  width: 86px;
}
.goodsInfoWapper {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}
.goodRight {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
  margin-left: 10px;
  .goodTitle {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 8px;
  }
  .goodId {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.85);
    margin-bottom: 8px;
  }
  .goodPrice {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.85);
  }
}
.selected-con{
  position: absolute;
  right: 0px;
  top: 0px;
  width: 36px;
}
.selected-con-bg {
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 12;
}
.selected-con-icon{
  display: block;
  position: absolute;
  top: 3px;
  right: 3px;
  z-index: 13;
}
</style>
